<div class="header-bar">
  <h1>Search Criteria</h1>
</div>

<div class="content-container" style="position: relative">
  <div class="card card-w-title ui-g">
    <div class="ui-g-12">
      <div class="ui-g-6 ui-lg-6 ui-sm-12 ui-md-6">
        <form [formGroup]="searchCriteriaForm" autocomplete="off">
          <div style="margin-right: 10px">
            <p-panel header="Pick-up Details">
              <div>
                <div class="ui-grid-row">
                  <div class="ui-g-12">
                    <div class="ui-grid-col-4"><label for="pickupLocation">Location</label></div>
                    <div class="ui-grid-col-8">
                      <input
                        pInputText
                        id="pickupLocation"
                        [(ngModel)]="pickupLocation"
                        formControlName="pickupLocation"
                        tabindex="4"
                        maxlength="35"
                        #pickupLocationRef
                      />
                    </div>
                  </div>
                </div>
                <div class="ui-grid-row">
                  <div class="ui-g-12">
                    <div class="ui-grid-col-4">
                      <label for="pickupDistance">Radius (miles)</label>
                    </div>
                    <div class="ui-grid-col-8">
                      <p-spinner
                        size="30"
                        [min]="0"
                        [max]="10000"
                        formControlName="pickupDistance"
                        id="pickupDistance"
                        [(ngModel)]="pickupDistance"
                      ></p-spinner>
                    </div>
                  </div>
                </div>
                <div class="ui-grid-row">
                  <div class="ui-g-12">
                    <div class="ui-grid-col-4"><label for="pickUpFrom">From</label></div>
                    <div class="ui-grid-col-8">
                      <div class="route-address md-inputfield">
                        <datetime-picker
                          [(ngModel)]="pickUpFrom"
                          name="pickUpFrom"
                          formControlName="pickUpFrom"
                          [class.route-calendar]="true"
                          [minutesInterval]="30"
                        ></datetime-picker>
                        <div
                          *ngIf="inputErrorToShow(searchCriteriaForm.controls['pickUpFrom'])"
                          class="ui-message ui-messages-error ui-corner-all"
                        >
                          {{ searchCriteriaForm.controls['pickUpFrom']._errors.error }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ui-grid-row">
                  <div class="ui-g-12">
                    <div class="ui-grid-col-4"><label for="pickUpTo">To</label></div>
                    <div class="ui-grid-col-8">
                      <div class="route-address md-inputfield">
                        <datetime-picker
                          [(ngModel)]="pickUpTo"
                          name="pickUpTo"
                          formControlName="pickUpTo"
                          [class.route-calendar]="true"
                          [minutesInterval]="30"
                        ></datetime-picker>
                        <div
                          *ngIf="inputErrorToShow(searchCriteriaForm.controls['pickUpTo'])"
                          class="ui-message ui-messages-error ui-corner-all"
                        >
                          {{ searchCriteriaForm.controls['pickUpTo']._errors.error }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </p-panel>
          </div>
          <div style="margin-top: 20px; margin-right: 10px">
            <p-panel header="Drop-off Details">
              <div class="ui-grid-row">
                <div class="ui-g-12">
                  <div class="ui-grid-col-4"><label for="dropoffLocation">Location</label></div>
                  <div class="ui-grid-col-8">
                    <input
                      pInputText
                      id="dropoffLocation"
                      [(ngModel)]="dropoffLocation"
                      formControlName="dropoffLocation"
                      tabindex="4"
                      maxlength="35"
                      #dropoffLocationRef
                    />
                  </div>
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-g-12">
                  <div class="ui-grid-col-4">
                    <label for="dropoffDistance">Radius (miles)</label>
                  </div>
                  <div class="ui-grid-col-8">
                    <p-spinner
                      size="30"
                      [min]="0"
                      [max]="10000"
                      formControlName="dropoffDistance"
                      id="dropoffDistance"
                      [(ngModel)]="dropoffDistance"
                    ></p-spinner>
                  </div>
                </div>
              </div>
            </p-panel>
          </div>
        </form>
      </div>
      <div class="ui-g-6 ui-sm-12 ui-md-6 ui-lg-6">
        <map-control
          [height]="355"
          [(origin)]="fromLocation"
          [(destination)]="toLocation"
          [radiusPoints]="locationPoins"
        >
        </map-control>
      </div>
      <div style="clear: both"></div>
    </div>
    <div class="ui-g-12">
      <button
        type="button"
        (click)="close()"
        pButton
        icon="fa ui-icon-close"
        label="Close"
        class="ui-button btn-to-right"
      ></button>
      <!--
      <button
        type="button"
        pButton
        icon="fa ui-icon-check"
        label="Search"
        (click)="search()"
        class="ui-button green-btn btn-to-right"
        [disabled]="!formIsValid()"
      ></button>-->
    </div>
  </div>
  <div>
    <p-table
      id="dtResult"
      selectionMode="single"
      [value]="items"
      [rows]="10"
      [responsive]="true"
      [paginator]="false"
      rowHover="true"
      [lazy]="false"
      [rowsPerPageOptions]="[5, 10, 20]"
      [pageLinks]="3"
      resizableColumns="true"
      [(selection)]="selectedJob"
      dataKey="id"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>From</th>
          <th>To</th>
          <th>Latest Pickup</th>
          <th>Latest Dropoff</th>
          <th>Movement Type</th>
          <th>Vehicles</th>
          <th>Buy Now</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
          <td>
            <div title="{{ tasksCountPostfix(item, inboxjobsService.addressStr(item.from)) }}">
              {{ tasksCountPostfix(item, inboxjobsService.addressStr(item.from)) }}
            </div>
          </td>
          <td>
            <div title="{{ tasksCountPostfix(item, inboxjobsService.addressStr(item.to)) }}">
              {{ tasksCountPostfix(item, inboxjobsService.addressStr(item.to)) }}
            </div>
          </td>
          <td>
            <div
              title="{{
                tasksCountPostfix(item, item.latestPickupDate | datex : 'ddd DD MMM HH:mm')
              }}"
            >
              {{ tasksCountPostfix(item, item.latestPickupDate | datex : 'ddd DD MMM HH:mm') }}
            </div>
          </td>
          <td>
            <div
              title="{{
                tasksCountPostfix(item, item.latestDropOffDate | datex : 'ddd DD MMM HH:mm')
              }}"
            >
              {{ tasksCountPostfix(item, item.latestDropOffDate | datex : 'ddd DD MMM HH:mm') }}
            </div>
          </td>
          <td>
            <div title="{item.movementType}}">
              {{ item.movementType }}
            </div>
          </td>
          <td>{{ item.vehiclesNum }}</td>
          <td>{{ item.supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!-- DATATABLES DEPRECATED ---
          <p-dataTabl id="dtResult" selectionMode="single" [value]="items" [rows]="10" [responsive]="true" [paginator]="false" rowHover="true"
                       [lazy]="false" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3"
                       resizableColumns="true" [(selection)]="selectedJob">

              <p-column field="pickup" header="From" [sortable]="useSortColumns" [editable]="false" [style]="{'width': '20%'}">
                  <ng-template pTemplate="body" let-item="rowData">
                      <div title="{{tasksCountPostfix(item, inboxjobsService.addressStr(item.from))}}">
                          {{tasksCountPostfix(item, inboxjobsService.addressStr(item.from))}}
                      </div>
                  </ng-template>
              </p-column>
              <p-column field="dropoff" header="To" [sortable]="useSortColumns" [editable]="false" [style]="{'width': '20%'}">
                  <ng-template pTemplate="body" let-item="rowData">
                      <div title="{{tasksCountPostfix(item, inboxjobsService.addressStr(item.to))}}">
                          {{tasksCountPostfix(item, inboxjobsService.addressStr(item.to))}}
                      </div>
                  </ng-template>
              </p-column>
              <p-column field="pickupLatest" header="Latest Pick-up" [sortable]="useSortColumns" [editable]="false" [style]="{'width': '10%'}">
                  <ng-template pTemplate="body" let-item="rowData">
                      <div title="{{tasksCountPostfix(item, item.latestPickupDate | datex:'ddd DD MMM HH:mm')}}">
                          {{tasksCountPostfix(item, item.latestPickupDate | datex:'ddd DD MMM HH:mm')}}
                      </div>
                  </ng-template>
              </p-column>
              <p-column field="dropoffLatest" header="Latest Drop-Off" [sortable]="useSortColumns" [editable]="false" [style]="{'width': '10%'}">
                  <ng-template pTemplate="body" let-item="rowData">
                      <div title="{{tasksCountPostfix(item, item.latestDropOffDate | datex:'ddd DD MMM HH:mm')}}">
                          {{tasksCountPostfix(item, item.latestDropOffDate | datex:'ddd DD MMM HH:mm')}}
                      </div>
                  </ng-template>
              </p-column>
              <p-column field="movementType" header="Movement Type" [sortable]="useSortColumns" [editable]="false" [style]="{'width': '10%'}">
                  <ng-template pTemplate="body" let-item="rowData">
                      <div title="{item.movementType}}">
                          {{item.movementType}}
                      </div>
                  </ng-template>
              </p-column>
              <p-column field="vehiclesNum" header="Vehicles" [sortable]="false" [style]="{'text-align' : 'center', 'width': '10%'}"
                        [editable]="false">
                  <ng-template let-item="rowData" pTemplate="body">
                      {{item.vehiclesNum}}
                  </ng-template>
              </p-column>
              <p-column field="supplierBuyPrice"
                        header="Buy Now" [style]="{'text-align' : 'center', 'width': '10%'}" [sortable]="useSortColumns" [editable]="false">
                  <ng-template let-item="rowData" pTemplate="body">
                      {{ item.supplierPrice | currency:'GBP':'symbol':'1.2-2' }}
                  </ng-template>
              </p-column>
          </p-dataTable>

          --->

    <div class="footerPanel ui-grid-row">
      <button
        label="Job Details"
        [disabled]="!selectedJob"
        class="btn-to-right"
        (click)="editJob(selectedJob)"
        pButton
      ></button>

      <button
        label="Watch"
        [disabled]="!selectedJob"
        class="btn-to-right"
        (click)="watchJob(selectedJob)"
        pButton
      ></button>
    </div>
  </div>

  <div
    style="
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: gray;
      opacity: 0.3;
    "
    *ngIf="isBusy"
  >
    <img
      src="assets/images/loader.gif"
      style="margin-left: 45%; margin-top: 15%"
      width="50"
      height="50"
      alt="load"
    />
  </div>
</div>
